var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-container',{staticClass:"blog-page-container"},[_c('b-row',[_c('b-col',_vm._l((_vm.blogPosts),function(post){return _c('div',{key:post.id},[_c('blog-post',{attrs:{"postId":post.id}})],1)}),0)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }